import { render, staticRenderFns } from "./LogoSocialMediaVersionSection.vue?vue&type=template&id=d28a73ae"
import script from "./LogoSocialMediaVersionSection.vue?vue&type=script&lang=ts"
export * from "./LogoSocialMediaVersionSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoSocialMediaVersionSection.vue?vue&type=style&index=0&id=d28a73ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports